
import { ColumnStartOrder, ColumnName, ColumnResult, ColumnNoc, ColumnExpander } from "components/common/TableColumns"
import { hasConfig } from "components/sports/mtb/helper/MtbHelpers"
import Label from "components/general/Label"
import Competitor from 'components/presentation/Competitor';

export function ColumnTeamComponents({
    disableSort = false,
    className = 'text-start',
    headerClassName = 'text-start',
    label = 'HeaderName',
    hideNoc = false
}) {
    return (
        {
            Header: (props) => {
                const row = props?.data[0]

                let lbl
                if (label !== 'HeaderName') {
                    lbl = label
                } else {
                    lbl = row?.participant?.__typename === 'Person' ? 'HeaderName' : 'HeaderTeam'
                }
                return (
                    <Label data={lbl} />
                )
            },
            accessor: (props) => (props?.participant?.name.toUpperCase()),
            id: 'Name',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            hideNoc: hideNoc,
            Cell: (props) => {
                const row = props.cell.row.original
                let data
                if (row?.teamAthletes) {
                    data = row?.teamAthletes?.find(x => x !== undefined)?.athlete
                } else {
                    data = row?.participant
                }
                return (
                    <> {row?.teamAthletes?.sort((a, b) => a.order - b.order).map((item, key) => (
                        <div key={'teamComponents-' + key + item.code} >
                            <Competitor hidePicture={true} hideNoc={hideNoc} {...item?.athlete} />
                        </div>
                    ))}
                    </>
                )
            }
        }
    )
}

export function TableColumns(columnsAdded) {

    return (
        [
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnTeamComponents({}),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({ type: hasConfig ? 'alwaysTrue' : 'alwaysTrue' })

        ]
    )
}

export function TableColumnsSM(columnsAdded) {

    return (
        [
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnTeamComponents({ label: "HeaderTeam" }),
            ColumnResult({ label: "HeaderTotalPoints" }),
            ColumnExpander({ type: hasConfig ? 'alwaysTrue' : 'alwaysTrue' })
        ]
    )
}

export default TableColumns
